import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircleIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { AuthShell } from '../../components/portal/AuthShell';
import { usePortalAuth } from '../../context/PortalAuth';

/** Landing point for the emailed link. Verifies once, then routes to onboarding or the dashboard. */
export function PortalVerify() {
  const [params] = useSearchParams();
  const {
    verify
  } = usePortalAuth();
  const navigate = useNavigate();
  const [error, setError] = React.useState<string | null>(null);
  const attempted = React.useRef(false);
  React.useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    const token = params.get('token');
    const email = params.get('email');
    if (!token || !email) {
      setError('This link is incomplete. Please request a new one.');
      return;
    }
    verify(email, token).then(result => {
      if (!result.ok) {
        setError(result.error ?? 'This link could not be verified.');
        return;
      }
      navigate(result.needsOnboarding ? '/portal/welcome' : '/portal/dashboard', {
        replace: true
      });
    });
  }, [params, verify, navigate]);
  return <AuthShell title="Signing you in" data-id="element-3273" data-mp="1eo91ldwc96ti">
      {error ? <div role="alert" data-id="element-3274" data-mp="1jfhc6d9emy89">
          <AlertCircleIcon className="h-9 w-9 text-[#FF8B7A]" aria-hidden="true" data-id="element-3275" data-mp="1jgsq35wkdmd3" />
          <h1 className="mt-6 font-display text-[28px] font-light text-ink" data-id="element-3276" data-mp="1ofdgkdm0kroc">This link cannot be used</h1>
          <p className="mt-4 text-[16px] leading-relaxed text-body" data-id="element-3277" data-mp="1sfnxumf9b4ii">{error}</p>
          <Button to="/portal/login" className="mt-8" data-id="element-3278" data-mp="1xfs3tiijgguh">
            Request a new link
          </Button>
        </div> : <div role="status" aria-live="polite" data-id="element-3279" data-mp="22dk53352pfbc">
          <div className="h-9 w-9 animate-spin rounded-full border-2 border-line border-t-gold motion-reduce:animate-none" aria-hidden="true" data-id="element-3280" data-mp="22c93n9z3ojne" />
          <h1 className="mt-6 font-display text-[28px] font-light text-ink" data-id="element-3281" data-mp="7zsqdp7w0591">Signing you in</h1>
          <p className="mt-3 text-[16px] text-body" data-id="element-3282" data-mp="3w4il4fqg7015">Checking your link.</p>
        </div>}
    </AuthShell>;
}